import {
  CampaignImageType,
  getAdminCampaignsIdImagesImageTypePath,
  getApiUrl,
  getPublicCampaignsCodeImagesImageTypePath,
} from "Infrastructure/Api/Api";

type CampaignWithImages = {
  code?: string | null;
  logoFileName?: string | null;
  landingImageFileName?: string | null;
  thankYouImageFileName?: string | null;
  iconFileName?: string | null;
};

type AdminCampaignWithImages = CampaignWithImages & {
  campaignID?: number | null;
};

const imageTypeToFileNameKey: Record<
  CampaignImageType,
  keyof CampaignWithImages
> = {
  [CampaignImageType.Logo]: "logoFileName",
  [CampaignImageType.Landing]: "landingImageFileName",
  [CampaignImageType.ThankYou]: "thankYouImageFileName",
  [CampaignImageType.Icon]: "iconFileName",
};

const appendCacheKey = (url: string, cacheKey?: number) =>
  cacheKey ? `${url}?v=${cacheKey}` : url;

const getFileName = (
  campaign: CampaignWithImages,
  imageType: CampaignImageType,
) => campaign[imageTypeToFileNameKey[imageType]];

export const getCampaignImageUrl = (
  campaign: CampaignWithImages | undefined | null,
  imageType: CampaignImageType,
  cacheKey?: number,
): string | undefined => {
  if (!campaign?.code) {
    return undefined;
  }

  if (!getFileName(campaign, imageType)) {
    return undefined;
  }

  const path = getPublicCampaignsCodeImagesImageTypePath(
    campaign.code,
    imageType,
  );

  return appendCacheKey(`${getApiUrl()}${path}`, cacheKey);
};

export const getAdminCampaignImageUrl = (
  campaign: AdminCampaignWithImages | undefined | null,
  imageType: CampaignImageType,
  cacheKey?: number,
): string | undefined => {
  if (!campaign?.campaignID) {
    return undefined;
  }

  if (!getFileName(campaign, imageType)) {
    return undefined;
  }

  const path = getAdminCampaignsIdImagesImageTypePath(
    campaign.campaignID,
    imageType,
  );

  return appendCacheKey(`${getApiUrl()}${path}`, cacheKey);
};
